<app-image
  class="avatar"
  src="assets/icon/default-avatar.png"
  [alt]="'ALT_IMG.AVATAR' | translate"
></app-image>
<p class="name">
  {{ userName }}
</p>
